import './App.css';
import Card from './components/Card';

function App() {
  return (
    <main className="App">
      <Card />
    </main>
  );
}

export default App;
